module.exports = __webpack_public_path__ + "img/notFound.33d48bef.svg";